import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'lib/translate';
import { setPageTitle } from 'actions/header';
import Overview from 'containers/LeaveRequests/LeaveRequestsOverview';

const Leaves = () => {
	const dispatch = useDispatch();
	const translate = useTranslate();

	useEffect(() => {
		dispatch(setPageTitle(translate('Leave Applications')));
	}, [dispatch]);

	return (
		<div>
			<Overview />
		</div>
	);
};

export default Leaves;